<template>
  <div class="cards mx-auto shadow cards-height pb-5">
    <div class="card-title-border h1 mb-4 bg-light py-2 primary-font">
      About
    </div>
    <div class="my-3 about-padding">
      <img class="d-inline-block border border-dark rounded-circle" id="face" src="https://tech.maxico.xyz/20150326_180324.jpg" width="192.5" height="160">
    </div>
    <span class="about-container about-padding">
      Experienced Software Engineer with a demonstrated history of working in
      the computer software industry. Skilled in JavaScript (Vue.js, Angular, Node.js), .NET, Python,
      and Java. I've been employed as a Software Engineer for more
      than half a decade, and built this site from the ground up to share some insights
      I've acquired with my experience. Contact me through email to inquire about how
      I can help you with your business needs!
    </span>
  </div>
</template>

<script>
export default {
  name: "AboutView",
};
</script>

<style>
/* Changing span to div and using text-align causes run time error */
.about-padding {
  padding-left: 20%;
  padding-right: 20%;
  text-align: center;
}
.about-container {
  padding-bottom: 5rem;
  width: 80rem;
}
#face:hover {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  /* 
  -webkit-animation-duration: calc(40);
  https://developer.mozilla.org/en-US/docs/Web/CSS/animation-duration
  animation-duration: calc(40); 
  */
  -webkit-animation-name: rotateIn;
  animation-name: rotateIn;
  transform-origin: center;
  /* -webkit-transform-origin: top left;
  transform-origin: top left; */
}
</style>
